var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-button"},[_c('svgicon',{attrs:{"name":"plus"}}),_c('div',{staticClass:"body-text-1",attrs:{"name":"add-button"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }